import api from "../api";
import type { MasterStatusListDto } from "../models/MasterStatus";
import type { ManualDto } from "../models/Manual";

type ApiResponse<T> = { statusCode: number; message?: string; data?: T };

export type UpdateManualStatusRequest = {
  status: string;
  updatedBy: string;
  updatedOn: string;
};

export async function fetchReviewPartsWithManualStatus(
  oem: string,
  role: string
): Promise<MasterStatusListDto> {
  const { data } = await api.get<ApiResponse<MasterStatusListDto>>(
    `/Parts/componentsManual/by-role-status/${oem}/${role}`
  );
  if (data?.statusCode === 200 && data.data) return data.data;
  return { statuses: [], items: [] };
}

export async function updateManualStatus(
  oem: string,
  manualId: number,
  payload: UpdateManualStatusRequest
): Promise<ApiResponse<ManualDto>> {
  const { data } = await api.patch<ApiResponse<ManualDto>>(
    `/Manuals/${oem}/status/${manualId}`,
    payload
  );
  return data;
}
